const PetitionError = require('../../petitionError');
const { getAnonymous, postAnonymous, post } = require('../../httpRequester');

class InitTwoFactorException extends PetitionError {
  constructor(code) {
    super('Init two factor', code);
  }
}

class Verify2FAException extends PetitionError {
  constructor(code) {
    super('Verify two factor', code);
  }
}

async function initTwoFactor(payload) {
  try {
    const response = await getAnonymous(`2fa/init?email=${payload.email}&token=${payload.token}`);

    if (response.result === InitTwoFactorException.success) {
      return response.twoFactor;
    }
    throw new InitTwoFactorException(response.result);
  } catch (error) {
    console.error(error);
  }
}

async function verifyTwoFactor(payload, token) {
  try {
    const response = await post('2fa/verify', payload, token);

    if (response.result === Verify2FAException.success) {
      return response.twoFactor;
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

async function configTwoFactor(payload) {
  try {
    const response = await postAnonymous(
      `2fa/config?token=${payload.token}`,
      {
        email: payload.email,
        status: payload.status,
      }
    );

    if (response.result === Verify2FAException.success) {
      return response.twoFactor;
    }

  } catch (error) {
    console.error('❌ configTwoFactor error:', error);
    throw error;
  }
}

module.exports = { initTwoFactor, InitTwoFactorException, verifyTwoFactor, Verify2FAException , configTwoFactor};
